import RichText from 'components/rich-text';
import styles from '../collection-object-package-page.module.scss';
import type { PortableTextBlock } from '@portabletext/types';

export default function AboutTabPanel({ about }: AboutTabPanelProps) {
	return (
		<div className={styles.about}>
			<RichText value={about} />
		</div>
	);
}

interface AboutTabPanelProps {
	about?: Array<PortableTextBlock>;
}
